
export const CURRENCY_NAMES = {
  GBP: 'پوند',
  USD: 'دلار',
  USDT: 'تتر',
  EUR: 'یورو',
  TMN: 'تومان',
  IRT: 'تومان',
  IRR: 'ریال',
  AED: 'درهم امارات',
  AFN: 'افغانی',
  ALL: 'لک آلبانی',
  AMD: 'درام ارمنستان',
  AUD: 'دلار استرالیا',
  AZN: 'منات آذربایجان',
  BDT: 'تاکا بنگلادش',
  BHD: 'دینار بحرین',
  BRL: 'رئال برزیل',
  CAD: 'دلار کانادا',
  CHF: 'فرانک سوئیس',
  CNY: 'یوان چین',
  EGP: 'پوند مصر',
  HKD: 'دلار هنگ کنگ',
  IDR: 'روپیه اندونزی',
  INR: 'روپیه هند',
  JPY: 'ین ژاپن',
  KWD: 'دینار کویت',
  KZT: 'تنگه قزاقستان',
  MXN: 'پزو مکزیک',
  MYR: 'رینگیت مالزی',
  NOK: 'کرون نروژ',
  NZD: 'دلار نیوزیلند',
  OMR: 'ریال عمان',
  PKR: 'روپیه پاکستان',
  PLN: 'زلوتی لهستان',
  QAR: 'ریال قطر',
  RUB: 'روبل روسیه',
  SAR: 'ریال عربستان',
  SEK: 'کرون سوئد',
  SGD: 'دلار سنگاپور',
  THB: 'بات تایلند',
  TRY: 'لیر ترکیه',
  UAH: 'گریونیا اوکراین',
  UZS: 'سوم ازبکستان',
  VND: 'دونگ ویتنام',
  ZAR: 'رند آفریقای جنوبی',
} as const;